# Sono & Descanso: Sonecas, Noite & Espaços Calmos

O descanso apoia a recuperação, o humor e a saúde imunológica. Pets dormem bastante, mas um bom sono ainda depende de rotina, conforto e um ambiente tranquilo.

<ArticleImage
  src="/images/guide/sleep-rabbit.jpg"
  alt="Relógio em uma mesa de cabeceira"
  caption="Uma rotina consistente ajuda os pets a relaxar e adormecer mais rápido."
/>

---

<Section emoji="🌙" title="Padrões de Sono Saudáveis">

<Tip label="Faixas típicas" text="Cães adultos costumam dormir 12–14 horas; gatos podem dormir 12–16 horas. Filhotes e idosos dormem mais." />
<Tip label="Sonecas diurnas" text="Sonecas curtas são normais — observe energia e apetite no geral." />
<Tip label="Mudanças à noite" text="Se o sono mudar de repente, anote outros sintomas como apetite ou hábitos de banheiro." />

</Section>

<ArticleImage
  src="/images/guide/sleep-cat-cozy.jpg"
  alt="Luz suave da janela"
  caption="Um espaço calmo e aconchegante favorece um descanso mais profundo."
/>

<Section emoji="🏡" title="Crie uma Zona de Sono Tranquila">

<Tip label="Conforto" text="Ofereça caminhas macias e uma temperatura confortável para o tipo de pelagem do pet." />
<Tip label="Pouco ruído" text="Mantenha a área de descanso longe de TVs altas, portas ou corredores movimentados." />
<Tip label="Lugar seguro" text="Caixas ou caminhas fechadas ajudam alguns pets a se sentirem protegidos." />

</Section>

<Section emoji="📖" title="Rotina para Dormir">

<Tip label="Mesmo horário" text="Tente manter a última refeição, o último xixi e o horário das luzes consistentes." />
<Tip label="Desacelerar" text="Brincadeira leve ou uma escovação calma ajudam a baixar a energia." />
<Tip label="Sinais de luz" text="Diminua as luzes à noite para sinalizar a hora de dormir." />

</Section>

<Section emoji="🩺" title="Quando Procurar Ajuda">

<Tip label="Noites inquietas" text="Andar de um lado para o outro, ofegar ou acordar com frequência pode indicar desconforto ou ansiedade." />
<Tip label="Sono excessivo" text="Letargia repentina merece avaliação veterinária, especialmente com mudanças no apetite." />
<Tip label="Sinais de dor" text="Rigidez, mancar ou choramingar podem atrapalhar o sono e indicar dor." />

</Section>

<Disclaimer title="⚠️ Lembrete Amigável">
Este guia é educativo e não substitui orientação veterinária. Se mudanças no sono persistirem ou vierem acompanhadas de outros sintomas, procure seu veterinário.
</Disclaimer>
